import DeleteIcon from '@mui/icons-material/Delete';
import {IconButton, Table, TableBody, TableCell, TableHead, TableRow, TextField} from '@mui/material';
import Box from '@mui/material/Box';
import type * as React from 'react';
import {useDeleteCapacityDefault} from '@/hooks/capacity/useDeleteCapacityDefault';
import {useUpdateCapacityDefault} from '@/hooks/capacity/useUpdateCapacityDefault';
import type {CapacityDefaultWithLabel} from '@/types/CapacityDefault';

type Props = {
    data : CapacityDefaultWithLabel[];
};

const Example = ({data} : Props) : React.ReactElement => {
    const updateCapacityDefaultMutation = useUpdateCapacityDefault();
    const deleteCapacityDefaultMutation = useDeleteCapacityDefault();

    const handleUpdateCapacityDefault = (capacityDefault : CapacityDefaultWithLabel, hours : number) => {
        updateCapacityDefaultMutation.mutate({
            ...capacityDefault,
            hours: hours,
        });
    };

    const handleDeleteCapacityDefault = (capacityDefault : CapacityDefaultWithLabel) => {
        if (capacityDefault.associateCapacityDefaultID) {
            deleteCapacityDefaultMutation.mutate({
                capacityDefaultId: capacityDefault.associateCapacityDefaultID,
            });
        }
    };

    return <Table size="small">
        <TableHead>
            <TableRow>
                <TableCell sx={{fontWeight: 800}}>Label</TableCell>
                <TableCell sx={{fontWeight: 800}}>Hours</TableCell>
                <TableCell sx={{fontWeight: 800}}>Delete</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {data.map(datum => {
                return <TableRow key={`table-row-${datum.associateID}-${datum.timeLabelID}`}>
                    <TableCell>{datum.label ? datum.label.name : 'No Label'}</TableCell>
                    <TableCell>
                        <TextField
                            name={`capacity-default-${datum.associateID}-${datum.timeLabelID}`}
                            variant="outlined"
                            sx={{
                                padding: 0,
                                margin: 0,
                                width: '72px',
                            }}
                            onBlur={event => {
                                const newValue = Math.abs(parseFloat(event.target.value));
                                handleUpdateCapacityDefault(datum, newValue > 168 ? 168 : newValue);
                            }}
                            defaultValue={datum.hours}
                            InputProps={{
                                inputProps: {
                                    style: {
                                        paddingBottom: '8px',
                                        paddingTop: '8px',
                                    },
                                },
                                sx: {
                                    pr: '2px',
                                },
                            }}
                        />
                    </TableCell>
                    <TableCell>
                        <Box sx={{display: 'flex', gap: '2ch', alignItems: 'center'}}>
                            <IconButton
                                aria-label="delete"
                                onClick={() => {
                                    handleDeleteCapacityDefault(datum);
                                }}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <DeleteIcon/>
                            </IconButton>
                        </Box>
                    </TableCell>
                </TableRow>;
            })}
        </TableBody>
    </Table>;
};

export default Example;
